import React, { useCallback, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { CHIP_STYLE_TYPES } from '@CommonConstants';
import { CHOICE_RESULT_KEYS } from '@Services/Editor/Constants';

import { deleteResultPropertyChipState, setResultProbabilityCondition } from '@Services/Editor';

import Chip from '@Components/Common/Chip';

const ProbabilityConditionChip = ({ processId, choiceId, resultId, results }) => {
  const dispatch = useDispatch();

  const processesResults = useSelector(({ editor }) => editor.processes[processId].choices[choiceId].results);

  const findData = processesResults.find(v => v.resultId === resultId);
  const { resultPropertyChipState, probability } = findData;
  const probabilityConditionChipVisible = resultPropertyChipState[CHOICE_RESULT_KEYS.PROBABILITY];

  const probabilityConditionRef = useRef(null);
  const hasPropertyInResultPropertyChip = processesResults.some(
    v => v.resultPropertyChipState[CHOICE_RESULT_KEYS.PROBABILITY] === true,
  );

  const handleDispatchProbabilityCondition = useCallback(
    event => {
      const {
        target: { value },
      } = event;
      const checkedProbability = Number(value.replace(/[^0-9]/g, ''));

      if (checkedProbability <= 100) {
        dispatch(
          setResultProbabilityCondition({
            processId,
            choiceId,
            resultId,
            probability: checkedProbability,
          }),
        );
      }
    },
    [dispatch],
  );

  const handleDeleteProbabilityConditionClick = useCallback(() => {
    dispatch(
      deleteResultPropertyChipState({
        processId,
        choiceId,
        resultId,
        type: [CHOICE_RESULT_KEYS.PROBABILITY],
        state: false,
      }),
    );
  }, [dispatch]);

  const calculateProbability = () => {
    // answer 변수를 초기화합니다.
    let totalProbability = 0;

    // results 배열을 순회하면서 probability 값을 더합니다.
    results?.forEach(item => {
      if (item.resultId !== 0 && item.probability) {
        totalProbability += item.probability;
      }
    });

    // 100에서 총합을 빼서 answer 값을 구합니다.
    const answer = 100 - totalProbability;

    return answer < 0 ? 0 : answer;
  };

  // if (!probabilityConditionChipVisible && !hasPropertyInResultPropertyChip) {
  //   return null;
  // }

  // 확룰 요소가 있는지?
  if (!hasPropertyInResultPropertyChip) {
    return null;
  }
  return (
    <Chip
      chipRef={probabilityConditionRef}
      type={CHIP_STYLE_TYPES.BG_TEXT}
      label="확률"
      placeholder="100"
      value={probability}
      onChange={handleDispatchProbabilityCondition}
      onDelete={handleDeleteProbabilityConditionClick}
      probabilityConditionChipVisible={!probabilityConditionChipVisible}
      calculateProbability={calculateProbability()}
      resultId={resultId}
      results={results}
    />
  );
};

export default ProbabilityConditionChip;
